import styled from 'styled-components';
import { Button, Flexbox, Icon } from '@hiiretail/synergy-ui';

export const BusinessUnitsContainer = styled(Flexbox)`
  overflow-x: auto;
  overflow-y: auto;
  flex-wrap: wrap;
  gap: 8px;
`;

export const BusinessUnit = styled(Flexbox)`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 4px 8px;
  height: 25px;
  font-size: 14px;
  align-items: center;
  margin-right: 8px;
`;

export const StyledButton = styled(Button)`
  background: none;
  padding: 0;
  
  :hover {
    background-color: #EEEEEE;
  }
  
  :active {
    background-color: #DFE3E8;
  }
`;

export const StyledPlusIcon = styled(Icon.Plus)`
  display: flex;
`;

export const StyledCancelIcon = styled(Icon.Cancel)`
  display: flex;
`;

export const StyledLockIcon = styled(Icon.Locker)`
  display: flex;
`;
